module.exports = __webpack_public_path__ + "static/img/music_fest.e031ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/music_fest.jpg
// module id = ACDn
// module chunks = 1